export default class FiltroConsultarCartaProposta {
    constructor () {
        this.NumeroSolicitacao = undefined;
        this.NumeroCartaProposta = undefined;
        this.ProdutoId = undefined;
        this.OrcamentoProdutoId = undefined;
        this.Status = undefined;
        this.DataInicioBaixa = undefined;
        this.DataFinalBaixa = undefined;
        this.DataInicioEmissao = undefined;
        this.DataFinalEmissao = undefined;
        this.UnidadeId = null;
        this.ClienteId = undefined;
        this.RepresentanteId = undefined;
        this.ConsultarDadosClienteAgrupador = undefined;
        this.OrdenarPorDataHora = true;
        this.OrdernarPorNumeroCartaProposta = undefined;
    }
}